import type { VoiceSessionState } from './hooks/useVoiceSession';

export function VoiceMicFAB({ visible, state, onPress }: {
    visible: boolean;
    state: VoiceSessionState;
    onPress: () => void;
}) {
    if (!visible) return null;

    const active = state.status !== 'idle';
    const label = active ? 'Cancel voice' : 'Talk to Moji';

    return (
        <button
            type="button"
            aria-label={label}
            aria-pressed={active}
            className={`fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full border shadow-lg transition ${
                active
                    ? 'border-cockpit-panel/25 bg-cockpit-panel text-cockpit'
                    : 'border-cockpit-panel/15 bg-brand text-on-brand'
            }`}
            style={{ marginBottom: 'env(safe-area-inset-bottom)', marginRight: 'env(safe-area-inset-right)' }}
            onClick={onPress}
        >
            {active ? <StopIcon /> : <MicIcon />}
        </button>
    );
}

function MicIcon() {
    return (
        <svg aria-hidden="true" viewBox="0 0 24 24" className="h-7 w-7" fill="none">
            <rect x="9" y="3" width="6" height="11" rx="3" stroke="currentColor" strokeWidth="2" />
            <path d="M5 11a7 7 0 0 0 14 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 18v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M9 21h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

function StopIcon() {
    return (
        <svg aria-hidden="true" viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor">
            <rect x="7" y="7" width="10" height="10" rx="2" />
        </svg>
    );
}

